import { useEffect, useState } from 'react';

export const useExternalScript = (initialUrl) => {
    let [url, setUrl] = useState(initialUrl);
    let [state, setState] = useState(initialUrl ? 'loading' : 'idle');

    const handleScript = (e) => {
        setState(e.type === 'load' ? 'ready' : 'error');
    };

    const removeScript = (scriptUrl) => {
        const script = document.querySelector(`script[src="${scriptUrl}"]`);
        if (script) {
            script.removeEventListener('load', handleScript);
            script.removeEventListener('error', handleScript);
            script.remove();
        }
    };

    useEffect(() => {
        if (!url) {
            setState('idle');
            return;
        }

        let script = document.querySelector(`script[src="${url}"]`);

        if (!script) {
            script = document.createElement('script');
            script.type = 'application/javascript';
            script.src = url;
            script.async = true;
            document.body.appendChild(script);
        }

        // If the script is already loaded, update the state immediately
        if (script.readyState === 'complete' || script.readyState === 'loaded' || script.getAttribute('data-loaded') === 'true') {
            setState('ready');
        } else {
            // Only add listeners if they are not already added
            const onLoad = (e) => {
                script.setAttribute('data-loaded', 'true');
                handleScript(e);
            };
            script.addEventListener('load', onLoad);
            script.addEventListener('error', handleScript);

            // Cleanup
            return () => {
                script.removeEventListener('load', onLoad);
                script.removeEventListener('error', handleScript);
            };
        }
        // If it was already loaded, no need to clean up listeners
        return undefined;
    }, [url]);

    return [state, setUrl, removeScript];
};
